var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebration2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 104.112C91.0163 104.112 104 91.1281 104 75.1118C104 59.0956 91.0163 46.1118 75 46.1118C58.9837 46.1118 46 59.0956 46 75.1118C46 91.1281 58.9837 104.112 75 104.112Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.882 65.5358L73.233 77.1848L66.89 70.8418C65.507 69.4588 63.271 69.4588 61.888 70.8418C60.505 72.2248 60.505 74.4608 61.888 75.8438L70.732 84.6878C71.422 85.3778 72.327 85.7248 73.233 85.7248C74.139 85.7248 75.044 85.3778 75.734 84.6878L89.884 70.5378C91.267 69.1548 91.267 66.9188 89.884 65.5358C88.501 64.1518 86.266 64.1518 84.882 65.5358Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.606 131.143L27.269 129.949C27.357 129.791 27.598 129.855 27.595 130.036L27.572 131.402C27.57 131.538 27.718 131.624 27.835 131.554L29.006 130.852C29.161 130.759 29.338 130.935 29.245 131.091L28.543 132.262C28.473 132.379 28.559 132.528 28.695 132.525L30.061 132.502C30.242 132.499 30.307 132.74 30.148 132.828L28.954 133.491C28.835 133.557 28.835 133.729 28.954 133.795L30.148 134.458C30.306 134.546 30.242 134.787 30.061 134.784L28.695 134.761C28.559 134.759 28.473 134.907 28.543 135.024L29.245 136.195C29.338 136.35 29.162 136.527 29.006 136.434L27.835 135.732C27.718 135.662 27.569 135.748 27.572 135.884L27.595 137.25C27.598 137.431 27.357 137.496 27.269 137.337L26.606 136.143C26.54 136.024 26.368 136.024 26.302 136.143L25.639 137.337C25.551 137.495 25.31 137.431 25.313 137.25L25.336 135.884C25.338 135.748 25.19 135.662 25.073 135.732L23.902 136.434C23.747 136.527 23.57 136.351 23.663 136.195L24.365 135.024C24.435 134.907 24.349 134.758 24.213 134.761L22.847 134.784C22.666 134.787 22.601 134.546 22.76 134.458L23.954 133.795C24.073 133.729 24.073 133.557 23.954 133.491L22.76 132.828C22.602 132.74 22.666 132.499 22.847 132.502L24.213 132.525C24.349 132.527 24.435 132.379 24.365 132.262L23.663 131.091C23.57 130.936 23.746 130.759 23.902 130.852L25.073 131.554C25.19 131.624 25.339 131.538 25.336 131.402L25.313 130.036C25.31 129.855 25.551 129.79 25.639 129.949L26.302 131.143C26.368 131.262 26.539 131.262 26.606 131.143Z",
    fill: "#FF9500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.4393 26.1424C94.5643 23.9021 94.7401 21.7162 93.832 21.2601C92.9238 20.8041 91.2755 22.2505 90.1504 24.4909C89.0254 26.7312 88.8496 28.9171 89.7578 29.3732C90.6659 29.8292 92.3142 28.3828 93.4393 26.1424Z",
    fill: "#FF3049"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M128.235 114.825C129.08 113.59 127.294 110.9 124.246 108.817C121.198 106.734 118.043 106.047 117.199 107.283C116.354 108.519 118.14 111.209 121.188 113.292C124.236 115.374 127.391 116.061 128.235 114.825Z",
    fill: "#196EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M100.947 112.174C102.402 112.174 103.581 110.994 103.581 109.54C103.581 108.085 102.402 106.906 100.947 106.906C99.4923 106.906 98.313 108.085 98.313 109.54C98.313 110.994 99.4923 112.174 100.947 112.174Z",
    fill: "#FF9500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.8101 99.5269C17.5838 99.5269 18.2111 98.8996 18.2111 98.1259C18.2111 97.3521 17.5838 96.7249 16.8101 96.7249C16.0363 96.7249 15.4091 97.3521 15.4091 98.1259C15.4091 98.8996 16.0363 99.5269 16.8101 99.5269Z",
    fill: "#FF9500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.821 43.8408C103.595 43.8408 104.222 43.2136 104.222 42.4398C104.222 41.6661 103.595 41.0388 102.821 41.0388C102.047 41.0388 101.42 41.6661 101.42 42.4398C101.42 43.2136 102.047 43.8408 102.821 43.8408Z",
    fill: "#FF9500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.619 77.0117C125.393 77.0117 126.02 76.3845 126.02 75.6107C126.02 74.837 125.393 74.2097 124.619 74.2097C123.845 74.2097 123.218 74.837 123.218 75.6107C123.218 76.3845 123.845 77.0117 124.619 77.0117Z",
    fill: "#FF3049"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.721 124.02C65.4948 124.02 66.122 123.393 66.122 122.619C66.122 121.845 65.4948 121.218 64.721 121.218C63.9473 121.218 63.32 121.845 63.32 122.619C63.32 123.393 63.9473 124.02 64.721 124.02Z",
    fill: "#FF3049"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.962 91.9858C35.7357 91.9858 36.363 91.3586 36.363 90.5848C36.363 89.8111 35.7357 89.1838 34.962 89.1838C34.1882 89.1838 33.561 89.8111 33.561 90.5848C33.561 91.3586 34.1882 91.9858 34.962 91.9858Z",
    fill: "#196EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.041 14.9138C48.8148 14.9138 49.442 14.2866 49.442 13.5128C49.442 12.7391 48.8148 12.1118 48.041 12.1118C47.2673 12.1118 46.64 12.7391 46.64 13.5128C46.64 14.2866 47.2673 14.9138 48.041 14.9138Z",
    fill: "#196EFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.228 55.9719C44.0018 55.9719 44.629 55.3447 44.629 54.5709C44.629 53.7972 44.0018 53.1699 43.228 53.1699C42.4543 53.1699 41.827 53.7972 41.827 54.5709C41.827 55.3447 42.4543 55.9719 43.228 55.9719Z",
    fill: "#196EFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.188 70.4328C122.144 70.4328 123.729 68.8475 123.729 66.8918C123.729 64.9362 122.144 63.3508 120.188 63.3508C118.232 63.3508 116.647 64.9362 116.647 66.8918C116.647 68.8475 118.232 70.4328 120.188 70.4328Z",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.807 36.8818C51.7626 36.8818 53.348 35.2964 53.348 33.3408C53.348 31.3852 51.7626 29.7998 49.807 29.7998C47.8514 29.7998 46.266 31.3852 46.266 33.3408C46.266 35.2964 47.8514 36.8818 49.807 36.8818Z",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.9 111.864C37.8556 111.864 39.441 110.278 39.441 108.323C39.441 106.367 37.8556 104.782 35.9 104.782C33.9444 104.782 32.359 106.367 32.359 108.323C32.359 110.278 33.9444 111.864 35.9 111.864Z",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.84 44.1328V50.6128",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3099 48.2119L22.2429 52.2519",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.402 57.3768L23.084 55.9348",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.541 64.7267L20.729 58.8877",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1389 64.7267L16.9509 58.8877",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27795 57.3768L14.596 55.9348",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.37 48.2119L15.437 52.2519",
    stroke: "#FF3049",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.554 118.534V125.015",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.024 122.613L93.957 126.654",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.116 131.779L94.798 130.337",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.254 139.129L92.442 133.29",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.853 139.129L88.665 133.29",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.992 131.779L86.31 130.337",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.084 122.613L87.151 126.654",
    stroke: "#196EFF",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.322 15.4309V23.2509",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.542 20.353L125.428 25.229",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.066 31.4119L126.442 29.6719",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.993 40.2808L123.601 33.2358",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65 40.2808L119.043 33.2358",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.577 31.4119L116.201 29.6719",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.101 20.353L117.215 25.229",
    stroke: "#FF9500",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration2);
export default __webpack_public_path__ + "static/media/celebration2.dafc0b6b42f5a054c027b2764ff127a1.svg";
export { ForwardRef as ReactComponent };